import { Check as CheckIcon } from '@mui/icons-material';
import { Checkbox, CheckboxProps, useTheme } from '@mui/material';

export const DropdownCheckbox = (props: CheckboxProps) => {
  const { palette, utils } = useTheme();
  const { disabled } = props;

  const boxSizeRem = utils.clamp(12, 19);
  const iconSizeRem = utils.clamp(9, 14.5);

  // Colors when enabled vs disabled
  const color = {
    uncheckedBg: disabled
      ? palette.action.disabledBackground
      : palette.mapBlue[600],
    uncheckedBorder: disabled ? palette.action.disabled : palette.mapBlue[300],
    checkedBg: disabled
      ? palette.action.disabledBackground
      : palette.common.white,
    checkStroke: disabled ? palette.action.disabled : palette.mapBlue[700],
  };

  const UncheckedIcon = (
    <span
      style={{
        width: boxSizeRem,
        height: boxSizeRem,
        display: 'inline-block',
        borderRadius: 4,
        backgroundColor: color.uncheckedBg,
        border: `1px solid ${color.uncheckedBorder}`,
        opacity: disabled ? 0.7 : 1,
      }}
    />
  );

  const CheckedIcon = (
    <span
      style={{
        width: boxSizeRem,
        height: boxSizeRem,
        display: 'inline-block',
        borderRadius: 4,
        backgroundColor: color.checkedBg,
        position: 'relative',
        opacity: disabled ? 0.7 : 1,
      }}
    >
      <CheckIcon
        sx={{
          position: 'absolute',
          top: '15%',
          left: '15%',
          width: iconSizeRem,
          height: iconSizeRem,
          stroke: color.checkStroke,
          strokeWidth: 2,
          fill: 'none',
        }}
      />
    </span>
  );

  return (
    <Checkbox
      {...props}
      disableRipple
      icon={UncheckedIcon}
      checkedIcon={CheckedIcon}
      sx={{
        padding: 0,
        '&:hover': { backgroundColor: 'transparent' },
      }}
    />
  );
};
